import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'

import { EuiPage, EuiPageBody, EuiPageHeader, EuiPageHeaderSection, EuiPanel, EuiTitle } from '@elastic/eui'

import { RootState } from 'app/rootReducer'

import { WhiteLabel } from '../../api/interfaces'
import { AgencyV2ClientPageLayout } from '../../components/layouts/AgencyV2ClientPageLayout'
import { useWhiteLabel } from '../../whiteLabel/WhiteLabelContext'
import { AudiencePixel, audiencePixelDescription } from './AudiencePixel'

export const AudiencePixelPage = () => {
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const whiteLabel = useWhiteLabel()

  return (
    <EuiPage className='euiPage--platform'>
      {whiteLabel?.getWhiteLabel() === WhiteLabel.AgencyV2 ? (
        <AgencyV2ClientPageLayout helmetTitle={'Audience Pixel'} headerTitle={`Audience Pixel: ${currentAccount?.name}`} headerDescription={audiencePixelDescription}>
          <AudiencePixel showDescription={false} />
        </AgencyV2ClientPageLayout>
      ) : (
        <React.Fragment>
          <Helmet>
            <title>Audience Pixel</title>
          </Helmet>
          <EuiPageBody>
            <EuiPageHeader>
              <EuiPageHeaderSection>
                <EuiTitle>
                  <h1>Audience Pixel{whiteLabel?.isAgencies() && `: ${currentAccount?.name}`}</h1>
                </EuiTitle>
              </EuiPageHeaderSection>
            </EuiPageHeader>
            <EuiPanel grow={false}>
              <AudiencePixel showDescription={true} />
            </EuiPanel>
          </EuiPageBody>
        </React.Fragment>
      )}
    </EuiPage>
  )
}

export default AudiencePixelPage
